import { useState, useMemo } from 'react';

export const useYearFilter = (data, columns) => {
  const [selectedYear, setSelectedYear] = useState('all');

  const filteredData = useMemo(() => {
    if (!selectedYear || selectedYear === 'all') return data;

    // Buscar coluna PROCESSO (para emendas estaduais) ou EMENDA (para municipais)
    const processoColumn = columns.find(col => 
      col.header.toLowerCase().includes('processo')
    );
    const emendaColumn = columns.find(col => 
      col.header.toLowerCase().includes('emenda')
    );

    // Priorizar PROCESSO se existir (emendas estaduais)
    const yearColumn = processoColumn || emendaColumn;

    if (!yearColumn) return data;

    return data.filter(row => {
      const value = row[yearColumn.accessorKey];
      const year = extractYearFromValue(value, !!processoColumn);
      return year === selectedYear;
    });
  }, [data, columns, selectedYear]);

  return {
    selectedYear,
    setSelectedYear,
    filteredData
  };
};

const extractYearFromValue = (value, isProcessoColumn) => {
  if (!value) return null;
  
  const valueStr = String(value).trim();
  
  if (isProcessoColumn) {
    // Emendas Estaduais: extrair ano dos primeiros 4 dígitos da coluna PROCESSO
    // Formato: "2025/TR001836" ou "2025TR001836" -> extrai 2025
    const firstFourDigits = valueStr.substring(0, 4);
    const year = parseInt(firstFourDigits);
    
    if (!isNaN(year) && year >= 1900 && year <= 2100) {
      return year;
    }
  } else {
    // Emendas Municipais: extrair ano após a barra da coluna EMENDA
    // Formato: "0001/2024" -> extrai 2024
    const parts = valueStr.split('/');
    
    if (parts.length >= 2) {
      const lastPart = parts[parts.length - 1].trim();
      const year = parseInt(lastPart);
      
      if (!isNaN(year) && year >= 1900 && year <= 2100) {
        return year;
      }
    }
  }
  
  return null;
};
